import React from 'react';
import { Link } from 'react-router-dom';

const Category = (props) => {
  const {name, id} = props.category;
  return (
    <li className='mb-2'>
      <Link to={`/news/${id}`} className='relative font-medium text-indigo-600 before:absolute before:-bottom-1 before:h-0.5 before:w-full before:scale-x-0 before:bg-indigo-600 before:transition hover:before:scale-x-100'>{name}</Link> 
    </li> 
  );
};

export default Category;